import Accordion from "./Accordion";
customElements.define('accordion-list', Accordion);